import React from "react";
import { Route, Routes } from "react-router-dom";

import estilo from "./Aplicacion.module.css";
import Perfil from "./components/Perfil";
import Menu from "./components/Menu";

import Sobre from "./pages/Sobre";
import Portafolio from "./pages/Portafolio";
import Contacto from "./pages/Contacto";

function Aplicacion() {
  return (
    <div className={estilo.aplicacion} id="inicio">
      <Menu></Menu>

      <Routes>
        <Route path="/" element={<Perfil />} />
        <Route path="/sobre-mi" element={<Sobre />} />
        <Route path="/portafolio" element={<Portafolio />} />
        <Route path="/contacto" element={<Contacto />} />
        <Route path="*" element={<Perfil />} />
      </Routes>
    </div>
  );
}

export default Aplicacion;
